import React from 'react';

import lightPicture from '../../../assets/img/status/03_ampel-rot.png';
import calendarPicture from '../../../assets/img/status/04_calender.png';
import styles from './index.module.scss';

import Header from '.';

const TroyHeader = ({ payNowLabel }) => (
  <Header {...{ styles, calendarPicture, lightPicture, payNowLabel }} />
);

TroyHeader.propTypes = {};

export default TroyHeader;
